import React, { Component } from 'react'
import axios from 'axios'
import debounce from 'lodash.debounce'

import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'
import { Select } from '@softwaredev_cegeka/stix-form-select'

import { UserDataContext } from 'src/components/auth/withAuth'
import ImpersonateOrganizationMenu from './ImpersonateOrganizationMenu'

import styles from './userMenu.module.scss'

class ImpersonateUserMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            userData: {},
            users: [],
        }
    }

    static contextType = UserDataContext

    componentDidMount() {
        this.setState({ userData: this.context.data })
        this.loadUsers()
    }

    loadUsers = (name = null) => {
        const userData = this.context.data
        this.setState({ loading: true })
        if (userData.is_global_admin && !userData.is_local_user) {
            // add params based on args
            const params = {
                per_page: 20,
                sort: '+username',
            }

            if (name) {
                // determine if the user is passing first_name/last_name or is providing full name
                const nameArr = name.split(' ')
                if (nameArr.length === 1) {
                    params.first_name_like = name
                    params.last_name_like = name
                    params.email_like = name
                    params.use_or = true
                } else {
                    const firstName = nameArr.slice(0, 1)[0]
                    const lastName = nameArr.slice(1, nameArr.length).join(' ')
                    params.first_name_like = firstName
                    params.last_name_like = lastName
                }
            }

            axios
                .get(`/api/auth/users`, {
                    params: params,
                })
                .then(response => {
                    if (response.data) {
                        this.setState({ users: response.data.results })
                    }
                })
                .catch(ex => {
                    this.setState({ users: [] })
                })
        }
    }

    debouncedSearch = debounce(this.loadUsers, 100)

    userData() {
        if (this.state.users.length === 0) {
            return []
        }
        return this.state.users.map(user => ({
            value: user.username,
            label: `${user.first_name} ${user.last_name}`,
            id: user.id,
        }))
    }

    handleUserChange = chosen => {
        if (!chosen) {
            //Stop impersonating
            axios
                .delete('/api/auth/impersonator')
                .then(response => {
                    const data = {
                        is_global_admin: response.data.global_admin,
                        firstName: response.data.first_name,
                        lastName: response.data.last_name,
                        is_local_user: false,
                        username: response.data.username,
                        email: response.data.email,
                        organization_id: response.data.organization_id,
                    }
                    let permissions = null
                    this.getPermissions(data.username, null, {
                        Authorization: response.headers.authorization,
                    })
                        .then(permissionResponse => {
                            const { app_permissions } = permissionResponse.data
                            if (
                                !app_permissions ||
                                app_permissions.length === 0
                            ) {
                                permissions = []
                            } else {
                                permissions = app_permissions[0].actions
                            }
                            this.context.setImpersonatedUser(
                                response.headers.authorization,
                                null,
                                data,
                                null,
                                permissions
                            )
                        })
                        .catch(e => {
                            console.error(e)
                        })
                })
                .catch(e => {
                    console.error(e)
                })
        } else {
            // Impersonate user
            axios
                .post('/api/auth/impersonator', {
                    sub: chosen.value,
                })
                .then(response => {
                    const data = {
                        is_global_admin: response.data.global_admin,
                        firstName: response.data.first_name,
                        lastName: response.data.last_name,
                        is_local_user: false,
                        username: response.data.username,
                        email: response.data.email,
                        organization_id: response.data.organization_id,
                    }
                    let permissions = null
                    this.getPermissions(chosen.value, null, {
                        Authorization: response.headers.authorization,
                    })
                        .then(permissionResponse => {
                            const { app_permissions } = permissionResponse.data
                            if (
                                !app_permissions ||
                                app_permissions.length === 0
                            ) {
                                permissions = []
                            } else {
                                permissions = app_permissions[0].actions
                            }
                            this.context.setImpersonatedUser(
                                response.headers.authorization,
                                chosen,
                                data,
                                null,
                                permissions
                            )
                        })
                        .catch(e => {
                            console.error(e)
                        })
                })
                .catch(e => {
                    console.error(e)
                })
        }
    }

    getPermissions(username, organization, headers = {}) {
        let params = {}
        if (organization) {
            params.organization_id = organization
        }
        return axios.get(`/api/auth/users/${username}/app-permissions`, {
            params,
            headers: { ...axios.defaults.headers, ...headers },
        })
    }

    renderUserImpersonate() {
        if (this.context.impersonatedUser) {
            return (
                <>
                    <Dropdown.Header>Impersonate</Dropdown.Header>
                    <div className={styles.impersonateActive}>
                        <p>
                            You are impersonating{' '}
                            {this.context.impersonatedUser.label}.
                        </p>
                        <Button
                            variant={'naked'}
                            onClick={() => this.handleUserChange(null)}
                        >
                            <Icon icon={'close'} />
                        </Button>
                    </div>
                </>
            )
        }

        return this.context.data.is_global_admin ? (
            <>
                <Dropdown.Header>Impersonate</Dropdown.Header>
                <Select
                    srOnly
                    options={this.userData()}
                    isSearchable
                    isClearable
                    onInputChange={e => {
                        this.debouncedSearch(e)
                    }}
                    menuIsOpen
                    onChange={this.handleUserChange}
                    value={this.context.impersonatedUser}
                    placeholder={'Filter users'}
                />
            </>
        ) : null
    }

    render() {
        const { userData } = this.state
        return (
            <>
                <ImpersonateOrganizationMenu />
                {!userData.is_local_user ? this.renderUserImpersonate() : null}
            </>
        )
    }
}

export default ImpersonateUserMenu
